import React from 'react';
import { getCategoryMeta } from './categoryMeta';

export const ICON_PATHS = {
  cart: 'M3 4h2l2.2 11.2a1.5 1.5 0 0 0 1.5 1.2h7.7a1.5 1.5 0 0 0 1.5-1.2L20 7H6M9 20a1 1 0 1 0 0 .01M17 20a1 1 0 1 0 0 .01',
  food: 'M4 3v7a3 3 0 0 0 3 3v8M7 3v6M10 3v6M18 3c-1.5 0-2.5 2-2.5 5s1 4 2.5 4 2.5-1 2.5-4-1-5-2.5-5zM18 16v5',
  home: 'M4 11.5 12 4l8 7.5M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9',
  bolt: 'M13 3 4 14h7l-1 7 9-11h-7l1-7z',
  car: 'M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13M5 13h14v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H8v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4zM7.5 16h.01M16.5 16h.01',
  repeat: 'M4 8a6 6 0 0 1 10-2l2 2M4 8V4M4 8h4M20 16a6 6 0 0 1-10 2l-2-2M20 16v4M20 16h-4',
  play: 'M9 7.5v9l7-4.5-7-4.5z M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5z',
  heart: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z',
  income: 'M12 19V5M5 12l7-7 7 7',
  dots: 'M5 12h.01M12 12h.01M19 12h.01',
  home2: 'M4 11.5 12 4l8 7.5M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9',
  list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  plan: 'M3 13a9 9 0 1 0 9-9v9H3z',
  calendar: 'M7 3v3M17 3v3M4 8h16M5 6h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0',
  gear: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  plus: 'M12 5v14M5 12h14',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-3.5-3.5',
  chevR: 'M9 6l6 6-6 6',
  chevL: 'M15 6l-6 6 6 6',
  chevD: 'M6 9l6 6 6-6',
  bell: 'M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6zM9.5 19a2.5 2.5 0 0 0 5 0',
  bank: 'M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M3 10l9-6 9 6M3 10h18',
  card: 'M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7zM3 10h18M7 15h4',
  upload: 'M12 16V4M8 8l4-4 4 4M5 16v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3',
  tag: 'M3 11l8-8 9 9-8 8-9-9zM7.5 7.5h.01',
  logout: 'M16 17l5-5-5-5M21 12H9M12 19v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1',
  check: 'M5 12l5 5L20 6',
  edit: 'M4 20h4L18.5 9.5a2.1 2.1 0 0 0-3-3L5 17v3zM14 6l3 3',
  trash: 'M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13',
  alert: 'M12 9v4M12 17h.01M10.3 4l-7 12a2 2 0 0 0 1.7 3h14a2 2 0 0 0 1.7-3l-7-12a2 2 0 0 0-3.4 0z',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 8h.01M11 11h1v6h1',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  eyeOff: 'M2 12s3.5-7 10-7c1.4 0 2.6.3 3.7.8M22 12s-3.5 7-10 7c-1.4 0-2.6-.3-3.7-.8M9.9 9.9a3 3 0 0 0 4.2 4.2M3 3l18 18',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowDn: 'M12 5v14M6 13l6 6 6-6',
  wallet: 'M3 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2M3 7v10a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1v-3M3 7h15a1 1 0 0 1 1 1v3M17 12h.01',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  shield: 'M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z',
  refresh: 'M4 8a6 6 0 0 1 10-2l2 2M4 8V4M4 8h4M20 16a6 6 0 0 1-10 2l-2-2M20 16v4M20 16h-4',
  target: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  // Extra glyphs available for custom category icons
  bag: 'M6 8h12l-1 12H7L6 8zM9 8V6a3 3 0 0 1 6 0v2',
  coffee: 'M4 8h13v4a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8zM17 9h2a2 2 0 0 1 0 4h-2M7 2v2M11 2v2',
  gift: 'M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9zM3 7h18v4H3V7zM12 7v14M12 7S9 7 8 5a2 2 0 0 1 4-1 2 2 0 0 1 4 1c-1 2-4 2-4 2z',
  plane: 'M21 15l-8-3V5a1 1 0 0 0-2 0v7l-8 3v2l8-2v3l-2 1v2l3-1 3 1v-2l-2-1v-3l8 2v-2z',
  book: 'M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2V5zM4 19a2 2 0 0 1 2-2h13',
  phone: 'M7 3h10a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM10 18h4',
  paw: 'M5 14a2 2 0 1 0 0-.01M19 14a2 2 0 1 0 0-.01M9 8a2 2 0 1 0 0-.01M15 8a2 2 0 1 0 0-.01M12 13c-2.5 0-4 1.8-4 3.5S9.5 19 12 19s4-1 4-2.5S14.5 13 12 13z',
  fuel: 'M5 21V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v16M3 21h13M14 8h2a2 2 0 0 1 2 2v6a2 2 0 0 0 4 0V9l-3-3M7 8h4',
  dumbbell: 'M4 9v6M7 7v10M17 7v10M20 9v6M7 12h10',
  music: 'M9 18V5l12-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM21 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z',
  gamepad: 'M7 7h10a4 4 0 0 1 4 4l-1 6a2.5 2.5 0 0 1-4.5 1L13 16h-2l-2.5 2a2.5 2.5 0 0 1-4.5-1l-1-6a4 4 0 0 1 4-4zM6 12h4M8 10v4M15 11h.01M18 13h.01',
  shirt: 'M8 3l4 3 4-3 4 4-3 3v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V10L4 7l4-4z',
  graduation: 'M22 9L12 5 2 9l10 4 10-4zM6 11v5c0 1 2.5 3 6 3s6-2 6-3v-5',
  droplet: 'M12 3s6 5.5 6 10a6 6 0 0 1-12 0c0-4.5 6-10 6-10z',
  wifi: 'M5 12.5a10 10 0 0 1 14 0M8 16a5 5 0 0 1 8 0M12 20h.01',
  briefcase: 'M4 8h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zM8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18',
  coins: 'M9 8a6 3 0 1 0 0-.01M3 8v8a6 3 0 0 0 12 0M15 11a6 3 0 0 0 6 3M21 11v5a6 3 0 0 1-6 3',
  sparkle: 'M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6zM19 16l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z',
};

export function Icon({ name, size = 20, sw = 1.8, fill = 'none', style, className }) {
  const dval = ICON_PATHS[name] || ICON_PATHS.dots;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      className={className}
    >
      {dval.split(' M').map((seg, i) => (
        <path key={i} d={(i ? 'M' : '') + seg} />
      ))}
    </svg>
  );
}

// Pull a bare hostname out of whatever Plaid hands us ("https://www.wendys.com/menu"
// → "wendys.com"). Returns null when there's nothing usable.
function domainFromUrl(url) {
  if (!url) return null;
  const host = String(url)
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .split('/')[0]
    .trim()
    .toLowerCase();
  return host && host.includes('.') ? host : null;
}

/**
 * Merchant avatar with a graceful fallback chain:
 *   1. Plaid `logoUrl` (real merchant logo)
 *   2. favicon derived from the merchant `website`
 *   3. the category-coded <CatBadge> (always succeeds)
 * Each <img> that fails to load advances to the next source.
 */
export function MerchantIcon({ logoUrl, website, cat, size = 42, radius = 12 }) {
  const sources = React.useMemo(() => {
    const list = [];
    if (logoUrl) list.push(logoUrl);
    const domain = domainFromUrl(website);
    if (domain) list.push(`https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`);
    return list;
  }, [logoUrl, website]);

  const key = sources.join('|');
  const [idx, setIdx] = React.useState(0);
  // Reset when the merchant changes (list rows get reused as you scroll).
  React.useEffect(() => { setIdx(0); }, [key]);

  if (idx >= sources.length) return <CatBadge cat={cat} size={size} radius={radius} />;

  return (
    <span
      className="iconwrap"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <img
        src={sources[idx]}
        alt=""
        aria-hidden
        loading="lazy"
        onError={() => setIdx((i) => i + 1)}
        style={{ width: '100%', height: '100%', objectFit: 'contain', padding: Math.round(size * 0.2) }}
      />
    </span>
  );
}

export function CatBadge({ cat, size = 40, radius = 12 }) {
  const c = getCategoryMeta(cat);
  return (
    <span
      className="iconwrap"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: `color-mix(in srgb, ${c.tint} 15%, transparent)`,
        color: c.tint,
      }}
    >
      <Icon name={c.icon} size={size * 0.5} sw={1.9} />
    </span>
  );
}
